import Lottie from 'lottie-react';

import lottieCognitiveIssues from '../jsons/cognitive-issues.json';

const LottieCognitiveIssues = props => {
  return <Lottie animationData={lottieCognitiveIssues} loop={false} {...props} />;
};

export default LottieCognitiveIssues;
